<template>
  <div class="personal-add">
    <p class="title">个人客户还车</p>
    <div class="steps-wrapper">
      <ReturnCarStep
        :fixedStepIndex="originStep"
        :currentStepIndex="currentStep"
        :steps="stepList"
        @change="handelStepClick"
      />
    </div>
    <div>
      <keep-alive>
        <component
          :is="currentComponent"
          :orderId="queries.orderId"
          @returnCarBeginCompleted="handleReturnCarBeginCompleted"
          @checkoutCarCompleted="handleCheckoutCarCompleted"
        />
      </keep-alive>
    </div>
  </div>
</template>
<script>
import ReturnCarStep from '../components/returnCarStep.vue'
import ReturnCarBeginAdd from './components/returnCarBegin/index.vue' // 发起退车
import CheckoutCarAdd from './components/checkoutCar/index.vue' // 入库验车
import CheckoutOrderAdd from './components/checkoutOrder/index.vue' // 订单核算
import CheckoutExpenseAdd from './components/checkoutExpense/index.vue' // 费用结算
import ReturnCarEnd from './components/returnCarEnd/index.vue' // 结束退车
import ReturnCarBeginDetail from '@/pages/cars/returnCar/detail/components/returnCarBegin/index.vue'
import CheckoutCarDetail from '@/pages/cars/returnCar/detail/components/checkoutCar/index.vue'
import CheckoutOrderDetail from '@/pages/cars/returnCar/detail/components/checkoutOrder/index.vue'
import CheckoutExpenseDetail from '@/pages/cars/returnCar/detail/components/checkoutExpense/index.vue'
import { getOrderDetail } from '@/api/domain/returnLease'
import {
  ORDER_STATES,
  ORDER_TYPES,
  PERSONAL_RETURN_CAR_STEPS,
} from '@/pages/cars/returnCar/config'
import WindowCommunication from '@/utils/windowCommunication'

export default {
  provide() {
    return {
      orderType: ORDER_TYPES.personal.value,
      orderData: this.orderData,
    }
  },
  data() {
    return {
      originStep: -1,
      currentStep: -1,
      stepList: PERSONAL_RETURN_CAR_STEPS,
      orderData: {},
      queries: JSON.parse(decodeURIComponent(this.$route.query.query || '{}')),
    }
  },
  computed: {
    currentComponent() {
      const _map1 = new Map([
        [0, 'ReturnCarBeginAdd'],
        [1, 'CheckoutCarAdd'],
        [2, 'CheckoutOrderAdd'],
        [3, 'CheckoutExpenseAdd'],
        [4, 'ReturnCarEnd'],
      ])
      const _map2 = new Map([
        [0, 'ReturnCarBeginDetail'],
        [1, 'CheckoutCarDetail'],
        [2, 'CheckoutOrderDetail'],
        [3, 'CheckoutExpenseDetail'],
      ])
      if (this.currentStep === this.originStep) {
        return _map1.get(this.currentStep) || ''
      }
      return _map2.get(this.currentStep) || ''
    },
  },
  methods: {
    async init() {
      const { orderId } = this.queries
      if (orderId) {
        await this.getOrderDetail()
      }
      this.locateStepByOrderData()
    },
    updateQueries() {
      this.queries = JSON.parse(
        decodeURIComponent(this.$route.query.query || '{}'),
      )
    },
    locateStepByOrderData() {
      const { state } = this.orderData
      let step = 0

      if (state === ORDER_STATES.returnCarCheckoutWaiting.value) {
        step = 1
      } else if (state === ORDER_STATES.checkoutOrderWaiting.value) {
        step = 2
      } else if (state === ORDER_STATES.checkoutExpenseWaiting.value) {
        step = 3
      } else if (state === ORDER_STATES.closed.value) {
        step = 4
      }
      this.originStep = step
      this.currentStep = step
      this.sendMessage()
    },
    handelStepClick(stepIndex) {
      if (stepIndex <= this.originStep) {
        this.currentStep = stepIndex
      }
    },
    async getOrderDetail(orderId) {
      const _orderId = orderId || this.queries.orderId
      if (_orderId) {
        const res = await getOrderDetail({
          orderId: parseInt(_orderId, 10),
        })
        if (!res) return
        const { code, data } = res
        if (code === 1) {
          Object.keys(data).forEach((key) => {
            this.orderData[key] = data[key]
          })
        }
      }
    },
    next() {
      if (this.currentStep < this.stepList.length - 1) {
        this.originStep += 1
        this.currentStep += 1
      }
    },
    // 发起退车提交成功后直接进入入库验车
    async handleReturnCarBeginCompleted({ id, orderId }) {
      // 如果url已带参（id和orderId），不再进行url替换
      const urlQuery = JSON.parse(this.$route.query?.query || '{}')
      const queryObj = {
        id,
        orderId,
        scene: urlQuery.scene,
      }
      const queryStr = JSON.stringify(queryObj)
      const query = {
        query: queryStr,
      }

      if (urlQuery.id && urlQuery.orderId) {
        this.updateQueries()
        await this.getOrderDetail()
        this.locateStepByOrderData()
      } else {
        this.$router.replace({
          query,
        }, async () => {
          this.updateQueries()
          await this.getOrderDetail()
          this.locateStepByOrderData()
        })
      }
    },
    // 入库验车提交成功后直接进入退车核算
    async handleCheckoutCarCompleted() {
      await this.getOrderDetail()
      this.sendMessage()
      this.next()
    },
    sendMessage() {
      const urlQuery = JSON.parse(this.$route.query?.query || '{}')
      // 跨页面通信 通知签约提车车辆状态信息刷新
      if (urlQuery.scene) {
        const communication = new WindowCommunication('person_sign_contract')
        communication.send({
          type: 'unavailable_message',
          data: urlQuery.orderId,
        })
      }
    },
  },
  created() {
    this.init()
  },
  components: {
    ReturnCarStep,
    ReturnCarBeginAdd,
    CheckoutCarAdd,
    CheckoutOrderAdd,
    CheckoutExpenseAdd,
    ReturnCarBeginDetail,
    CheckoutCarDetail,
    ReturnCarEnd,
    CheckoutOrderDetail,
    CheckoutExpenseDetail,
  },
}
</script>
<style lang="scss" scoped>
.title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  font-weight: 600;
  font-size: 16px;
  color: #323233;
  margin-bottom: 14px;
}
.steps-wrapper {
  margin: 0 24px;
  padding: 24px 0 24px;
}
</style>
